import {
    AfterViewChecked,
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    QueryList,
    ViewChild,
    ViewChildren
} from '@angular/core';
import { NestedLink } from '../../../../shared/interfaces/nested-link';
import { DirectionService } from '../../../../shared/services/direction.service';
import { BehaviorSubject } from 'rxjs';
import { HeaderheaderService } from '../../header.service';
import { Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';

@Component({
    selector: 'app-header-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements AfterViewChecked, OnChanges {
    @Input() layout: 'classic' | 'topbar' = 'classic';
    @Input() items: any[] = []
    @Input() id: any

    @Output() itemClick: EventEmitter<NestedLink> = new EventEmitter<NestedLink>();

    @ViewChild('menuElement') elementRef!: ElementRef;
    @ViewChildren('submenuElement') submenuElements!: QueryList<ElementRef>;
    @ViewChildren('itemElement') itemElements!: QueryList<ElementRef>;

    hoveredItem: NestedLink | null = null;
    reCalcSubmenuPosition = false;
    dropdownOpen: boolean;


    get element(): HTMLDivElement {
        return this.elementRef.nativeElement;
    }

    constructor(
        private direction: DirectionService,
        private headerservice: HeaderheaderService,
        private Route: Router,
        private reportService: ReportService,
    ) {
    }
    ngOnChanges() {
        if (this.items) {
            this.items = this.items.filter(res => res.pageCaption != 'Sales Reseller Audit Trail Report');
        }
    }
    ngAfterViewChecked(): void {
        if (!this.reCalcSubmenuPosition) {
            return;
        }

        this.reCalcSubmenuPosition = false;

        const itemElement = this.getCurrentItemElement();
        const submenuElement = this.getCurrentSubmenuElement();

        if (!submenuElement || !itemElement) {
            return;
        }

        const menuRect = this.element.getBoundingClientRect();
        const itemRect = itemElement.getBoundingClientRect();
        const submenuRect = submenuElement.getBoundingClientRect();

        const viewportHeight = window.innerHeight;
        const paddingY = 20;
        const paddingBottom = Math.min(viewportHeight - itemRect.bottom, paddingY);
        const maxHeight = viewportHeight - paddingY - paddingBottom;

        submenuElement.style.maxHeight = `${maxHeight}px`;

        const submenuHeight = submenuElement.getBoundingClientRect().height;
        const position = Math.min(
            Math.max(
                itemRect.top - menuRect.top,
                0
            ),
            (viewportHeight - paddingBottom - submenuHeight) - menuRect.top
        );

        submenuElement.style.top = `${position}px`;

        if (this.direction.isRTL()) {
            const submenuLeft = menuRect.left - submenuRect.width;

            submenuElement.classList.toggle('menu__submenu--reverse', submenuLeft < 0);
        } else {
            const submenuRight = menuRect.left + menuRect.width + submenuRect.width;

            submenuElement.classList.toggle('menu__submenu--reverse', submenuRight > document.body.clientWidth);
        }
    }

    getCurrentItemElement(): HTMLDivElement | null {
        if (!this.hoveredItem) {
            return null;
        }

        const index = this.items.indexOf(this.hoveredItem);
        const elements = this.itemElements.toArray();

        if (index === -1 || !elements[index]) {
            return null;
        }

        return elements[index].nativeElement as HTMLDivElement;
    }

    getCurrentSubmenuElement(): HTMLDivElement | null {
        if (!this.hoveredItem) {
            return null;
        }

        const index = this.items.filter(x => x.items).indexOf(this.hoveredItem);
        const elements = this.submenuElements.toArray();

        if (index === -1 || !elements[index]) {
            return null;
        }

        return elements[index].nativeElement as HTMLDivElement;
    }
    RouteToPage(event: MouseEvent, pageUrl: string) {
        if (event.button === 0) { 
            event.preventDefault();
            pageUrl = pageUrl.trim().replace(/{isMenuClick}/g, '0');
            debugger
            this.Route.navigate([pageUrl])
        }

    }
}
